<template>
  <div class="search">
    <form class="search__form" @submit.prevent.stop="handleSubmit">
      <div class="search__group">
        <label class="search__input" for="main-search">
          <input
            id="main-search"
            name="main-search"
            type="search"
            :placeholder="$t('message.common.topbar.search.placeholder')"
            v-model="searchValue"
          />
        </label>
        <BaseSubmit class="search__submit" clear icon="search" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseSubmit from '@base/BaseSubmit'

export default {
  name: 'TheSearch',
  components: {
    BaseSubmit
  },
  data () {
    return {
      searchValue: ''
    }
  },
  computed: {
    ...mapGetters({
      search: 'filters/getSearch'
    })
  },
  mounted () {
    this.searchValue = this.search.value
  },
  methods: {
    ...mapActions({
      updateSearch: 'filters/updateSearch',
      updateOpen: 'header/updateOpen'
    }),
    handleSubmit () {
      if (this.searchValue !== '') {
        this.updateSearch({ value: this.searchValue })
        this.updateOpen(false)
        this.$router.push({ name: 'Search Results' })
      }
    }
  }
}
</script>

<style lang="scss">
.search{
  @include media("large"){
    display: none;
  }

  width: 100%;
  height: 100%;
  margin-left: layout("spacing")/2;
  margin-right: layout("spacing")/2;

  // Form

  &__form{
    width: 100%;
  }

  // Group

  &__group{
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: colors("foreground");

    label{
      margin: 0;
      width: 100%;
      height: 100%;
    }

    input[type="search"]{
      width: 100%;
      height: 100%;

      border: 0;
      margin: 0;
      font-size: 1.5rem;
      box-sizing: border-box;
      color: tint(colors("font"), 30%);
      background-color: colors("foreground");
    }

    button{
      @include hover{
        .icon{
          color: colors("primary");
        }
      }

      &.has-icon-center{
        padding: 1rem;
      }

      .icon{
        @include add-transition;
        color: tint(colors("font"), 30%);
        font-size: 2rem;
      }
    }
  }
}
</style>
